import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React, { FC } from 'react';

export const DropdownArrow: FC<SvgIconProps> = props => (
  <SvgIcon {...props}>
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path clipRule="evenodd" d="M3 6L8 11L13 6H3Z" fillRule="evenodd" />
    </svg>
  </SvgIcon>
);
